import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary } from './components/ErrorBoundary';
import { AuthProvider } from './lib/auth/context';
import { GraphQLProvider } from './lib/graphql/provider';
import { I18nProvider } from './lib/i18n/provider';
import { AppRoutes } from './routes/routes';

const isElectron =
  typeof window !== 'undefined' && !!(window as unknown as Record<string, unknown>).zoobook;

export function App() {
  if (isElectron && !document.body.classList.contains('electron-app')) {
    document.body.classList.add('electron-app');
  }

  return (
    <ErrorBoundary>
      {isElectron && <div className="electron-titlebar" />}
      <I18nProvider>
        <AuthProvider>
          <GraphQLProvider>
            <BrowserRouter>
              <AppRoutes />
            </BrowserRouter>
          </GraphQLProvider>
        </AuthProvider>
      </I18nProvider>
    </ErrorBoundary>
  );
}
